export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-shape/src/array.js
// module id = ../../../../d3-shape/src/array.js
// module chunks = 4